export default __webpack_public_path__ + "static/media/gw11.954843b5.webp";